import React from 'react';

const WorkComponent = () => {
    return (
        <section className="is-fullwidth is-stretched">
            <div className="stg-row infocolors-section-title is-boxed">
                <div className="stg-col-8 stg-offset-2">
                    <div className="align-center">
                        <h2 data-appear="fade-up" data-unload="fade-up">Our Work</h2>
                        <p className="infocolors-large-text" data-appear="fade-up" data-unload="fade-up" data-delay="100">We are proud of our work, and we are always looking for new challenges. Take a look at some of our recent portfolio:</p>
                    </div>
                </div>
            </div>
            <div className="swiper infocolors-carousel stg-bottom-gap-l" data-appear="fade-up" data-unload="fade-up" data-delay="200" data-count="4" data-m-count="1.5">
                <div className="swiper-wrapper">
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio01.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Photography</span>
                                <h6>Credits: Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio02.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Cinematography</span>
                                <h6>Credits: Shot By David John</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio03.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Event</span>
                                <h6>Credits: Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio04.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Cinematography</span>
                                <h6>Credits: Shot By David John</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio05.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Event</span>
                                <h6>Credits: Shot By David John</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio06.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Photography</span>
                                <h6>Credits: Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                    <div className="infocolors-block infocolors-portfolio-card swiper-slide">
                        <div className="infocolors-portfolio-card-image">
                            <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/portfolio/portfolio07.jpg"} alt="" width="1200" height="1200" />
                        </div>
                        <div className="infocolors-portfolio-card-footer">
                            <div className="infocolors-portfolio-card-title">
                                <span className="infocolors-meta">Photography</span>
                                <h6>Credits: Mathew Jibunor</h6>
                            </div>
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="https://www.instagram.com/the_infocolors/"><span className="sr-only">View Project</span></a>
                    </div>
                </div>
                <div className="swiper-pagination infocolors-dots"></div>
            </div>
            <div className="align-center" data-appear="fade-up" data-unload="fade-up" data-delay="100">
                <a href="portfolio-slider.html" className="infocolors-button">Discover Full Portfolio</a>
            </div>
        </section>
    );
};

export default WorkComponent;
